exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c_label[data-v-bf642914]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.box_doors[data-v-bf642914]{border:1px solid #e6e6e6;border-radius:6px;margin-left:40px;height:120px;min-height:120px;overflow:scroll}", ""]);

// exports
